const ROUTE_CONSTANTS = {
  HELP_ROUTE: '/test/:testslug/help',
  REPORT_ROUTE: '/test-report/:testSlug',
  MULTI_TAB_ROUTE: '/multi-session',
  FEEDBACK_ROUTE: '/test/:testslug/feedback',
  ONBOARDING_ROUTE: '/:testslug/onboarding/form',
  PROBLEM_ROUTE: '/test/:testslug/problem/:problemslug',
};

export default ROUTE_CONSTANTS;
